import { Black } from "src/styles/color";

const IconLandingPage = ({ width = 24, height = 24, fill = Black }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.58718 16.3882V13.8133C5.58718 13.156 6.12393 12.6231 6.78605 12.6231H9.20641C9.52437 12.6231 9.82931 12.7485 10.0541 12.9717C10.279 13.1949 10.4053 13.4977 10.4053 13.8133V16.3882C10.4033 16.6615 10.5112 16.9243 10.7052 17.1182C10.8991 17.3121 11.163 17.4212 11.4383 17.4212H13.0895C13.8607 17.4232 14.6011 17.1204 15.1471 16.5798C15.6931 16.0391 16 15.305 16 14.5394V7.20382C16 6.58538 15.7238 5.99876 15.246 5.60198L9.62865 1.14825C8.6515 0.367364 7.25146 0.392577 6.30349 1.20814L0.814326 5.60198C0.313887 5.98706 0.0147809 6.57543 0 7.20382V14.5319C0 16.1276 1.30306 17.4212 2.91046 17.4212H4.52403C5.09577 17.4212 5.56042 16.9633 5.56456 16.3957L5.58718 16.3882Z"
      fill={fill}
    />
  </svg>
);
export default IconLandingPage;
